module.exports = __webpack_public_path__ + "static/media/marketing-feature-tile-icon-03.57045527.svg";